
export default {
  name: 'CancelIcon',
}
